import LeafletMapContainer from "../../Componant/Maps/LeafletMap";

const LeafletMap = () => {
  return (
    <div className="page-body">
      <LeafletMapContainer />
    </div>
  );
};

export default LeafletMap;
